import {
  compose, getContext,
} from 'recompose';
import { connect } from 'react-redux';
import {
  pipe, pick, mergeRight,
} from 'ramda';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CreateTaskModal from './createTaskModal';
import rules from '../modalViewTasks/rules';
import withCRUDTask from '../../../../utils/enchancers/withCRUDTask';
import { setTaskData } from '../../../../utils/helpers/taskHelpers/crudHelper';
import { tasksActions } from '../../../../state/tasks';
import { leadsActions } from '../../../../state/leads';
import { STATUS, TASKS_WITHOUT_PROJECT } from '../../../../constants/tasks';

const mapDispatchToProps = ({
  addTask: tasksActions.addTaskRequest,
  getLeadTasks: leadsActions.getLeadTasksRequest,
  getLeadLogs: leadsActions.getLeadLogsRequest,
});

const enhance = compose(
  connect(null, mapDispatchToProps),
  withTranslation(['common', 'tasks']),
  getContext({
    setSelectedLeadId: PropTypes.func.isRequired,
    selectedLeadId: PropTypes.any,
  }),
  withCRUDTask({
    rules,
    data: () => null,
    modalName: 'createTaskModal',
    onSubmit: (formValues, {
      resetForm,
      props: {
        addTask, onCloseModal, initialValues, onSuccess, selectedLeadId, getLeadTasks,
        getLeadLogs,
      },
    }) => {
      const {
        submitButton,
      } = formValues;
      addTask(
        {
          ...setTaskData({
            ...formValues,
            projectId: TASKS_WITHOUT_PROJECT,
            project_id: null,
          }),
          status_id: STATUS.TO_DO.id,
          lead_id: selectedLeadId,
          client_id: selectedLeadId,
        }, {
          section: 'project',
          callbacks: {
            success: () => {
              resetForm(initialValues);
              if (submitButton !== 'saveAndCreate') {
                onCloseModal('createTaskModal');
              } else {
                const leftoverData = pipe(
                  pick(['assignee']),
                  mergeRight(initialValues),
                )(formValues);
                resetForm(leftoverData);
              }
              getLeadTasks({ id: selectedLeadId });
              getLeadLogs({ id: selectedLeadId });
              if (onSuccess) {
                onSuccess();
              }
            },
          },
        },
      );
    },
  }),
);

export default enhance(CreateTaskModal);
